import { useEffect } from "react";
import { create } from "zustand";

/**
 * Whether the app's navigation chrome (sidebar / rail / top bar / bottom
 * tabs) is shown. Screens that need the whole viewport — the try-on studio
 * while a customer is being served — hide it with `useHideAppChrome`.
 */
interface AppChromeState {
	hidden: boolean;
	setHidden: (hidden: boolean) => void;
}

export const useAppChrome = create<AppChromeState>((set) => ({
	hidden: false,
	setHidden: (hidden) => set({ hidden }),
}));

/** Hide the navigation while `active` (and while the calling screen is mounted). */
export const useHideAppChrome = (active: boolean) => {
	const setHidden = useAppChrome((state) => state.setHidden);
	useEffect(() => {
		setHidden(active);
		return () => setHidden(false);
	}, [active, setHidden]);
};

/**
 * Height a full-screen page has to work with when the chrome is hidden: the
 * viewport minus the offline bar, the page's vertical padding and the
 * safe areas. Set as `--stage-h` by AppLayout.
 */
export const STAGE_H = "var(--stage-h, calc(100dvh - var(--offline-bar, 0px) - 32px))";
